import React from 'react';
import { useTranslation } from 'react-i18next';
import _get from 'lodash/get';
import MessageBox from '@lib/components/SupportiveMessage/SupportiveMessageBox';
import FormItem from '@lib/components/ReactHookForm/FormItem';
import FormTemplateFieldNames from '@lib/enums/fieldNames/formTemplateFieldNames';
import CheckBoxSingleBool from '@lib/components/CheckBoxSingleBool/CheckBoxSingleBool';
import Select, {
  SelectComponents,
  SelectProps,
} from '@lib/components/Select/Select';
import { Values } from '@lib/interfaces/form';
import { GetLoadOptions } from '@lib/components/Select/types';
import MultiSelectValueContainer from '@lib/components/Select/components/MultiSelectValueContainer';

const multiSelectComponents = {
  ValueContainer: MultiSelectValueContainer,
} as unknown as SelectComponents;

type Props = {
  getTasksLoadOptions: GetLoadOptions;
  openTasksModal: () => void;
  values: Values;
};

export default function FormTemplateTaskAssignField(props: Props) {
  const { getTasksLoadOptions, openTasksModal, values } = props;
  const { t } = useTranslation();

  return (
    <MessageBox hasBottomSpace={false}>
      <FormItem
        name={`${FormTemplateFieldNames.Tasks}-enable`}
        element={CheckBoxSingleBool}
        componentProps={{
          label: t('update-tasks-form-template-version-label'),
          options: [{ label: 'checked', value: 'checked' }],
          fullWidth: false,
        }}
        hideErrorsSpace={
          !_get(values, `${FormTemplateFieldNames.Tasks}-enable`, false)
        }
      />
      <FormItem
        name={FormTemplateFieldNames.Tasks}
        element={Select}
        label={t('select-tasks')}
        isVisibleFn={(formValues: Values) =>
          _get(
            formValues,
            [`${FormTemplateFieldNames.Tasks}-enable`],
            false,
          ) as boolean
        }
        componentProps={
          {
            isAsync: true,
            isMulti: true,
            getLoadOptions: getTasksLoadOptions,
            defaultOptions: false,
            isClearable: true,
            isSearchable: false,
            openMenuOnClick: false,
            openMenuOnFocus: false,
            menuIsOpen: false,
            onSelectWrapperMouseDown: openTasksModal,
            components: multiSelectComponents,
          } as SelectProps
        }
      />
    </MessageBox>
  );
}
